
import React from "react";
import { styled } from "@mui/system";
import { Typography, Button } from "@mui/material";
import { primaryTxt } from "../constants/colors";

const Header = styled("h2")({
  fontFamily: "Roboto Slab",
  fontWeight: "600",
  marginTop: "30px",
  marginBottom: "40px",
  fontSize: "3rem",
  marginLeft: "10px",
  paddingLeft: "24px",
  color: "white",
});

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  //   backgroundColor: secondaryBg,
  height: "100%",
  // alignItems: "center",
});

const Text = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto Slab",
  color: primaryTxt,
  fontWeight: "300",
  padding: "0px 40px",
  marginBottom: "20px",
  [theme.breakpoints.down("sm")]: {
    padding: "0.2em",
  },
}));

const Sub = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto Slab",
  color: primaryTxt,
  fontSize: "18px",
  fontWeight: "400",
  // padding: "0px 40px",
  // marginBottom: "8px",
  // [theme.breakpoints.down("sm")]: {
  //   padding: "0.2em",
  // },
}));

const ContactDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignSelf: "center",
  marginBottom: "40px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));


export default function Amenities() {
  return (
    <>
      <Container>
        <Header id={"contact"}>Amenities</Header>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "0px 40px",
            marginBottom: "24px",
          }}
        >
          <Sub>1 King Bed</Sub>
          <Sub>1 Queen Bed</Sub>
          <Sub>1 full bed</Sub>
          <Sub>3 twin beds</Sub>
          <Sub>WiFi</Sub>
          <Sub>Wood burning stove</Sub>
          <Sub>2 work stations</Sub>
          <Sub>Trash Compactor</Sub>
          <Sub>Outdoor gas BBQ</Sub>
          <Sub>Coffee machine</Sub>
          <Sub>Washer and dryer</Sub>
        </div>
      </Container>
    </>
  );
}
